import { DateGroup } from './components/date-group'
import type { ActivityEntry } from './types'

export type { ActivityEntry } from './types'

export interface ActivityLogViewProps {
  entries: ActivityEntry[]
}

export function ActivityLogView({ entries }: ActivityLogViewProps) {
  const grouped = entries.reduce<Record<string, ActivityEntry[]>>((acc, entry) => {
    const date = entry.timestamp.split(',')[0] ?? entry.timestamp
    if (!acc[date]) acc[date] = []
    acc[date].push(entry)
    return acc
  }, {})

  return (
    <div className="mx-auto max-w-6xl py-2">
      <h1 className="text-2xl font-semibold tracking-tight text-foreground">Activity Log</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        A history of actions and events in your workspace
      </p>

      <div className="mt-6 space-y-4">
        {Object.entries(grouped).map(([date, dateEntries]) => (
          <DateGroup key={date} date={date} entries={dateEntries} />
        ))}
      </div>
    </div>
  )
}
